import { LOADING, FAILED, SUCCESS } from './constants';
import { listPermissionUser, userPermissionPost, userPermissionPut } from '../../utils/api';

export function fetchPermissionUser(scrollId = '', search = '') {
  return async (dispatch, getState) => {
    const state = getState();
    const KEY = 'Permission';
    const { page, totalPage } = state.permission.dataPermission.meta;
    if (scrollId && page > 1 && page >= totalPage) {
      return;
    }
    try {
      dispatch(loadingAction(true, KEY));
      const params = { search, page: 1, size: 100 };
      const { data, meta } = await listPermissionUser(params);
      dispatch(successAction({ data, meta }, KEY));
    } catch (error) {
      dispatch(failedAction(error.message, KEY));
    }
  };
}

export function createPermission(payload) {
  return async (dispatch) => {
    const key = 'SubmitPermission';
    dispatch(loadingAction(true, key));
    try {
      await userPermissionPost(payload);
      dispatch(successAction(false, 'SubmitUpdatePermission'));
      dispatch(successAction(true, key, payload.permission));
    } catch (error) {
      dispatch(successAction(false, 'SubmitUpdatePermission'));
      dispatch(failedAction(error.message, key));
    }
  };
}

export function editPermission(payload) {
  return async (dispatch) => {
    const key = 'SubmitUpdatePermission';
    dispatch(loadingAction(true, key));
    try {
      await userPermissionPut(payload);
      dispatch(successAction(false, 'SubmitPermission'));
      dispatch(successAction(true, key, payload.permission));
    } catch (error) {
      dispatch(successAction(false, 'SubmitPermission'));
      dispatch(failedAction(error.message, key));
    }
  };
}

export function failedAction(message, key) {
  return { type: FAILED, message, key };
}

export function loadingAction(isLoading, key) {
  return { type: LOADING, isLoading, key };
}

export function successAction(data, key, message) {
  return { type: SUCCESS, data, key, message: message };
}

